<arm-layout [summaryTitle]="'RESOURCE GROUP SUMMARY'">
  <div header>
    <div class="search-container">

      <arm-search (onSearch)="onSearch($event)"
                  [searchComponent]="resourceSearchComponent"
                  [searchData]="searchData"
                  [searchTerms]="searchTerms">
      </arm-search>
    </div>

    <div class="action-buttons">
      <arm-action-bar (addClick)="addItem()" [disableAdd]="isUnauthorized"
                      (deleteClick)="removeItem()" [disableDelete]="isActionDisabled()"
                      (refreshClick)="refresh()"
                      (editClick)="editItem()" [disableEdit]="isActionDisabled()"></arm-action-bar>

      <button [matMenuTriggerFor]="menu" class="more-actions" color="primary" mat-raised-button>
        <span>Actions</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button (click)="openColumnsConfiguration()" mat-menu-item>
          <span>Table columns</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div summary>
    <resource-groups-summary [selection]="selection">
    </resource-groups-summary>
  </div>

  <div main>
    <arm-table [displayedColumns]="displayedColumns" (pageChanged)="pageChanged($event)"
               (onSelection)="onSelection($event)" [data]="data.elements" [length]="data.totalElements"
               [isMultipleSelection]="isMultipleSelection"
               [isClientSide]="false"></arm-table>
  </div>
</arm-layout>
